/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type FetchOpenAPIv3FromURLForm2 = {
  /**
   * The URL to fetch the OpenAPI document from
   */
  url: string;
};

/** @internal */
export type FetchOpenAPIv3FromURLForm2$Outbound = {
  url: string;
};

/** @internal */
export const FetchOpenAPIv3FromURLForm2$outboundSchema: z.ZodMiniType<
  FetchOpenAPIv3FromURLForm2$Outbound,
  FetchOpenAPIv3FromURLForm2
> = z.object({
  url: z.string(),
});

export function fetchOpenAPIv3FromURLForm2ToJSON(
  fetchOpenAPIv3FromURLForm2: FetchOpenAPIv3FromURLForm2,
): string {
  return JSON.stringify(
    FetchOpenAPIv3FromURLForm2$outboundSchema.parse(fetchOpenAPIv3FromURLForm2),
  );
}
